"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useJwt = void 0;
var jwt = require("jsonwebtoken");
function useJwt() {
    var decode = function (token) {
        return jwt.decode(token);
    };
    return {
        decode: decode,
    };
}
exports.useJwt = useJwt;
